import React, { HTMLAttributes } from "react";
import { forwardRef } from "react";
import { useCombinedThemeMode } from "../../../../util/theme/useCombinedThemeMode";
import { CheckedState } from "../../../checkbox";
import { TypeRampV2 } from "../../../typography";
import { optionFontTheme } from "../selectV2Theme";
import { OptionBase } from "../shared/OptionBase";
import { MultiSelectCheckbox } from "./MultiSelectCheckbox";
export interface MultiSelectOptionProps extends HTMLAttributes<HTMLDivElement> {
    checkedState: CheckedState;
    height?: number;
    isDisabled?: boolean;
}

export const MultiSelectOption = forwardRef<HTMLDivElement, MultiSelectOptionProps>(
    ({ children, checkedState, ...props }, ref) => {
        const themeMode = useCombinedThemeMode();

        return (
            <OptionBase ref={ref} {...props}>
                <MultiSelectCheckbox checkedState={checkedState} aria-disabled={props.isDisabled} />
                <TypeRampV2 lineClamp={1} {...optionFontTheme.variant[themeMode]} style={{ color: "inherit" }}>
                    {children}
                </TypeRampV2>
            </OptionBase>
        );
    }
);

MultiSelectOption.displayName = "MultiSelectOption";
